// import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import * as yup from 'yup';

// const otherDataSchema = yup.object().shape({
//   professionalPosition: yup.string().required('Il campo è obbligatorio'),
//   unprofessionalCondition: yup.string().required('Il campo è obbligatorio'),
//   educationalQualification: yup.string().required('Il campo è obbligatorio'),
// });

const registryOfficeSchema = yup.object().shape({
  citizenship: yup
    .array()
    .required('Il campo è obbligatorio')
    .min(1, 'Deve essere presente almeno una cittadinanza'),
});

const regexCard = /^[a-zA-z]{2}\d{1,7}[a-zA-Z]{0,2}$/;

const messageErrorValidIdCard =
  'Numero carta di identità invalido, deve essere in uno di questi formati: AB0000198, CA00001AA o 1111101AB';

const documentSchema = yup.object().shape({
  yieldCard: yup.string().required('Il campo è obbligatorio'),
  number: yup.string().required('Campo obbligatorio').min(3, messageErrorValidIdCard),
  // .matches(regexCard, {
  //   message: messageErrorValidIdCard,
  // }),
  type: yup.string().required('Il campo è obbligatorio'),
  releaseDate: yup.date().typeError('Data non valida').nullable().required('Il campo è richiesto'),
  expirationDate: yup.date().typeError('Data non valida').nullable(),
  // .required('Il campo è richiesto'),
  releaseMode: yup.string().required('Il campo è obbligatorio'),
  typePayment: yup.string().required('Il campo è obbligatorio'),
  parentsPrint: yup.string().when('showParents', {
    is: true,
    then: yup.string().required('Il campo è obbligyieldCardatorio'),
    otherwise: yup.string().notRequired(),
  }),
  printCivilStatus: yup.string().required('Il campo è obbligatorio'),
  domicile: yup.string().required('Il campo è obbligatorio'),
  stature: yup.string().required('Il campo è obbligatorio'),
  hair: yup.string().required('Il campo è obbligatorio'),
  eyes: yup.string().required('Il campo è obbligatorio'),
  particularSigns: yup.string().notRequired(),
  numOfClearanceDocument: yup.string().notRequired(),
  hasPreviousCard: yup.boolean(),
  previousCard: yup.string().when('hasPreviousCard', {
    is: true,
    otherwise: yup.string().matches(regexCard, {
      message: messageErrorValidIdCard,
    }),
    then: yup.string().nullable(),
  }),
  // .required('Campo obbligatorio')
});

export const validationSchema = yup.object().shape({
  // otherData: otherDataSchema,
  registryOffice: registryOfficeSchema,
  document: documentSchema,
});
// .test('', '', (values) => {
//   const castedValues = values as unknown as ReleaseIdCard;

//   if (!castedValues.isResident && !castedValues.document?.numOfClearanceDocument) {
//     return new yup.ValidationError(
//       'Campo obbligatorio',
//       undefined,
//       'document.numOfClearanceDocument'
//     );
//   }

//   return true;
// });
